<div class="container">
    <p>Copyright &copy; 1x90 all rights reserved | Powerd By : Play Online Delhi</p>
</div>